import { render, staticRenderFns } from "./ordersTable.vue?vue&type=template&id=004100bc&scoped=true&"
import script from "./ordersTable.vue?vue&type=script&lang=js&"
export * from "./ordersTable.vue?vue&type=script&lang=js&"
import style0 from "./ordersTable.vue?vue&type=style&index=0&id=004100bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004100bc",
  null
  
)

export default component.exports